<template>
  <div id="app">
    <!-- 背景音乐元素 -->
    <audio ref="bgAudio" :src="musicSrc" loop preload="metadata" />
    
    <!-- 右上角音乐播放按钮 -->
    <div class="music-btn" @click="toggleMusic">
      <img v-if="isPlaying" :src="playIcon" alt="播放音乐" class="music-icon playing">
      <img v-else :src="pauseIcon" alt="暂停音乐" class="music-icon">
    </div>
    
    <router-view/>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

// 音乐相关
const bgAudio = ref(null)
const isPlaying = ref(false)
const musicSrc = require('@/assets/audio/bgmusic.mp3') // MP3音乐文件路径
const playIcon = require('@/assets/audio/music-play.png') // 播放图标（使用现有图片）
const pauseIcon = require('@/assets/audio/music-pause.png')// 暂停图标（使用现有图片）

// 切换音乐播放状态
const toggleMusic = async () => {
  try {
    if (isPlaying.value) {
      bgAudio.value.pause()
      isPlaying.value = false
    } else {
      await bgAudio.value.play()
      isPlaying.value = true
    }
  } catch (error) {
    console.error('音乐播放失败:', error)
  }
}

// 播放音乐的方法
const playMusic = async () => {
  try {
    if (bgAudio.value && isPlaying.value === false) {
      await bgAudio.value.play()
      isPlaying.value = true
    }
  } catch (error) {
    console.error('音乐播放失败:', error)
  }
}

// 页面加载后初始化
onMounted(() => {
  // 仅初始化，不自动播放音乐
  // 音乐将在用户点击按钮时播放
  
  // 将播放音乐的方法挂载到全局，以便其他组件调用
  window.playBgMusic = playMusic
})

// 将 playMusic 方法暴露给全局，以便其他组件调用
defineExpose({
  playMusic
})

      $.ajax({
            url: "//cgi.voc.com.cn/api/weixin/app.php?url="+encodeURIComponent(window.location.href),dataType: 'json',
      success: function (data) {
        $.each(data, function (index, result) {
          if (result['status'] == 1) {
            var appId = result['appId'],
            timestamp = result['timestamp'],
            nonceStr = result['nonceStr'],
            signature = result['signature'];
            setTimeout(() => {//寤惰繜
                wx.config({
                    debug: false,
                    appId: appId,
                    timestamp: timestamp,
                    nonceStr: nonceStr,
                    signature: signature,
                    jsApiList: [
                      'onMenuShareTimeline',
                      'onMenuShareAppMessage',
                      'onMenuShareQQ',
                      'onMenuShareWeibo',
                      'updateAppMessageShareData',
                      'updateTimelineShareData'
                    ],
                    openTagList:['wx-open-launch-app']
                 });
            },500);
          }
        });
      }
  });
  

  wx.ready(function () {
	  // 赋值shareTitle
	  const shareTitle = '【H5】@所有人，这份民族团结法治考卷，等你来挑战';
    const shareDesc = '@所有人，这份民族团结法治考卷，等你来挑战';
    const shareUrl = 'https://h5cgi.voc.com.cn/h5/hudong/2026/minzongdati_2026';
    const shareImg = 'https://img2.voc.com.cn/9/2026/01/21/d8e46727b7869157d508a62430027912ea7101701768961938634.jpeg?pid=36460899';

	  wx.updateAppMessageShareData({
          title: shareTitle,
          desc: shareDesc,
          link: shareUrl,
          imgUrl: shareImg,
          success: function (res) {
              //setShare();
          }
      });
      wx.updateTimelineShareData({
          title: shareTitle,
          link: shareDesc,
          imgUrl: shareImg,
          success: function (res) {
              //setShare();
          }
      });
    wx.onMenuShareAppMessage({
      title: shareTitle,
      desc: shareDesc,
      imgUrl: shareImg,
      link: shareUrl,
      success: function (res) {
          //setShare();
      }
    });

     wx.onMenuShareTimeline({
         title: shareTitle,
         imgUrl: shareImg,
         link: shareUrl,
         success: function (res) {
             //setShare();
         }
     });

     wx.onMenuShareQQ({
         title: shareTitle,
         desc: shareDesc,
         imgUrl: shareImg,
         link: shareUrl,
         success: function (res) {
             //setShare();
         }
     });

     wx.onMenuShareWeibo({
         title: shareTitle,
         desc: shareDesc,
         imgUrl: shareImg,
         link: shareUrl,
         success: function (res) {
             //setShare();
         }
     });
     wx.error(function(res){
     	 console.log("出问题了!");
      });
     
 });
 
</script>

<style lang="scss">
html,body{
  font-size: 10vw;
  overflow-x: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
*{
  margin: 0;
  padding: 0;
}

.music-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    background: rgba(255, 255, 255, 0.3);
  }
}

.music-icon {
  width: 70%;
  height: 70%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.music-icon.playing {
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
